export const MODULES = [
  {
    id: 0, name: "Cadet", range: "0 an — jeunes non professionnels", price: 5, priceLabel: "5 €",
    tagline: "Découvrir le monde du travail et construire ses premiers repères.",
    detail: "Orientation, premiers tests de positionnement et découverte des métiers. Offert, parce que tout commence par un premier pas."
  },
  {
    id: 1, name: "Débutant", range: "1 à 3 ans d'expérience", price: 10, priceLabel: "10 €",
    tagline: "Sécuriser ses premiers pas et apprendre à se connaître.",
    detail: "Bilan de compétences léger, coaching de prise de poste et centralisation de votre dossier de vie professionnelle."
  },
  {
    id: 2, name: "Confirmé", range: "4 à 5 ans d'expérience", price: 20, priceLabel: "20 €",
    tagline: "Consolider son expertise et donner du sens à sa trajectoire.",
    detail: "Tests approfondis, plan de progression et coaching à la demande pour passer les caps décisifs."
  },
  {
    id: 3, name: "Senior", range: "5 à 7 ans d'expérience", price: 40, priceLabel: "40 €",
    tagline: "Affirmer sa valeur et préparer les passages d'altitude.",
    detail: "Stratégie de carrière, visibilité, négociation et préparation aux responsabilités élargies."
  },
  {
    id: 4, name: "Young Leader", range: "7 à 12 ans d'expérience", price: 60, priceLabel: "60 €",
    tagline: "Prendre ses premiers mandats d'équipe avec assurance.",
    detail: "Coaching managérial, posture de leader et gestion des premières situations sensibles."
  },
  {
    id: 5, name: "Executive", range: "À partir de 12 ans d'expérience", price: 100, priceLabel: "100 €",
    tagline: "Diriger avec lucidité et tenir le cap dans la complexité.",
    detail: "Executive coaching confidentiel, sparring-partner stratégique et travail sur la prise de décision."
  },
  {
    id: 6, name: "CE_X", range: "Membres de COMEX — CEO, CFO, COO…", price: 1000, priceLabel: "1 000 €",
    tagline: "Un cercle d'exigence et de confidentialité absolue.",
    detail: "Accompagnement d'altitude pour les membres de comités exécutifs : gouvernance, influence, transitions de pouvoir."
  },
  {
    id: 7, name: "True Life", range: "La vraie vie — la retraite", price: 5, priceLabel: "5 €",
    tagline: "L'épanouissement de la vie dans sa plus grande maturité.",
    detail: "Transmission, mentorat, nouveaux engagements : la retraite comme accomplissement, offerte à nos membres."
  },
];

export const HERO_IMAGE = "https://images.unsplash.com/photo-1468581264429-2548ef9eb732?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjYWxtJTIwb2NlYW4lMjBtaW5pbWFsfGVufDB8fHx8MTc4NjE5NDM4MHww&ixlib=rb-4.1.0&q=85";
export const MIST_IMAGE = "https://images.unsplash.com/photo-1437502920657-db9708bfe2ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtb3VudGFpbiUyMG1pc3QlMjBlbGVnYW50fGVufDB8fHx8MTc4NjE5NDM4MHww&ixlib=rb-4.1.0&q=85";
export const TREE_IMAGE = "https://images.unsplash.com/photo-1646444570390-55a6131b8edb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbmF0dXJlJTIwdHJlZXxlbnwwfHx8fDE3ODYxOTQzODB8MA&ixlib=rb-4.1.0&q=85";
